import {Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {SharedModule} from "./modules/shared/shared.module";
import {JwtModule} from "@auth0/angular-jwt";
import {environment} from "../environments/environment";
import {AuthService} from "./services/auth.service";
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from "@angular/common/http";
import {AuthGuard} from "./services/authguard.service";
import {HttpRequestInterceptor} from "./interceptors/httprequest.interceptor";
import {LayoutMasterComponent} from "./components/layouts/layout-master/layout-master.component";
import {SigninComponent} from "./components/signin/signin.component";
import { DashboardComponent } from './components/dashboard/dashboard.component';
import {MenuModule} from "primeng/menu";
import {VersionComponent} from "./components/version/version.component";
import { RegistrationComponent } from './components/registration/registration.component';
import { RegistryComponent } from './components/registry/registry.component';
import {NgxSpinnerModule} from "ngx-spinner";
import {ToastModule} from "primeng/toast";
import {ToastrModule} from "ngx-toastr";
import {MessageService} from "primeng/api";
import {MessagesModule} from "primeng/messages";
import {MessageModule} from "primeng/message";
import {StyleClassModule} from "primeng/styleclass";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import { WorkComponent } from './components/work/work.component';
import { StudyComponent } from './components/study/study.component';
import { PreferencesComponent } from './components/preferences/preferences.component';
import { SettingsComponent } from './components/settings/settings.component';
import { ForgotComponent } from './components/forgot/forgot.component';
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {TranslateFakeLoader, TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
//import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import { ConfirmComponent } from './components/confirm/confirm.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DocumentComponent } from './components/document/document.component';
import { DocumentInsertComponent } from './components/document/document-insert/document-insert.component';
import { DocumentShowComponent } from './components/document/document-show/document-show.component';
import { AnnunciComponent } from './components/annunci/annunci.component';
import { DetailsComponent } from './components/annunci/details/details.component';
import {NgCircleProgressModule} from 'ng-circle-progress';
import { OtpDialogComponent } from './components/signin/otp-dialog/otp-dialog.component';
import {HeaderDashboardComponent} from "./components/header-dashboard/header-dashboard.component";


export let AppInjector: Injector;

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({
  declarations: [
    AppComponent,
    LayoutMasterComponent,
    SigninComponent,
    DashboardComponent,
    VersionComponent,
    RegistrationComponent,
    RegistryComponent,
    WorkComponent,
    StudyComponent,
    PreferencesComponent,
    SettingsComponent,
    ForgotComponent,
    ConfirmComponent,
    DocumentComponent,
    DocumentInsertComponent,
    DocumentShowComponent,
    AnnunciComponent,
    DetailsComponent,
    OtpDialogComponent,
    HeaderDashboardComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    HttpClientModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-center',
      preventDuplicates: true
    }),
    TranslateModule.forRoot({
      defaultLanguage: localStorage.getItem('lang') ?? 'it',
      useDefaultLang: true,
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgxSpinnerModule.forRoot({type: 'ball-scale-multiple'}),
    ToastModule,
    ConfirmDialogModule,
    MessagesModule,
    MessageModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: () => {
          return AuthService.AuthToken;
        },
        allowedDomains: [environment.apiDomain],
        disallowedRoutes: ['/oauth/token']
      }
    }),
    MenuModule,
    StyleClassModule,
    NgCircleProgressModule.forRoot({
      radius: 100,
      animationDuration: 300
    })

  ],
  providers: [
    AuthGuard,
    MessageService,
    TranslateService,
    {provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true},
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private injector: Injector) {
    AppInjector = this.injector;
  }
}
